export default "__VITE_ASSET__DCBYNr15__"